// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2Auwt","log":"ModalInventoryLogs_log__1UHXn","date":"ModalInventoryLogs_date__FMMm-","userName":"ModalInventoryLogs_userName__3I6F4"};